import { useRef, useState } from 'react'

interface CopyEmailProps {
  email: string
  className?: string
  linkClassName?: string
}

// Email link with a small "Copy" button that confirms in place
const CopyEmail = ({ email, className = '', linkClassName = '' }: CopyEmailProps) => {
  const [copied, setCopied] = useState(false)
  const timer = useRef<number | undefined>(undefined)

  const copy = async () => {
    try {
      await window.navigator.clipboard.writeText(email)
      setCopied(true)
      window.clearTimeout(timer.current)
      timer.current = window.setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard can be blocked; the mailto link still works
    }
  }

  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-3 ${className}`}>
      <a href={`mailto:${email}`} className={linkClassName}>
        {email}
      </a>
      <button
        type="button"
        onClick={copy}
        className="text-sm text-mute hover:text-ink underline underline-offset-4 decoration-rule"
      >
        <span aria-live="polite">{copied ? 'Copied' : 'Copy'}</span>
      </button>
    </span>
  )
}

export default CopyEmail
